export const OPEN_TO_ALL_CITIES = "all";
export const DEFAULT_STREET = "Adresse invalide";
export const STREET_NUMBER = "street_number";
export const STREET = "street";
export const DISTRICT = "district";
export const SUBLOCALITY = "subLocality";
